import { useCallback, useState } from "react";

export interface UseChipInputOptions {
  values: string[];
  onAdd: (value: string) => void;
  onRemove: (value: string) => void;
  validate: (value: string) => boolean;
}

export interface UseChipInput {
  draft: string;
  error: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleBlur: () => void;
}

export const useChipInput = ({
  values,
  onAdd,
  onRemove,
  validate,
}: UseChipInputOptions): UseChipInput => {
  const [draft, setDraft] = useState("");
  const [error, setError] = useState(false);

  const commit = useCallback(
    (raw: string) => {
      const candidate = raw.trim().replace(/,$/, "").trim();
      if (!candidate) return true;
      if (!validate(candidate)) {
        setError(true);
        return false;
      }
      if (!values.includes(candidate)) {
        onAdd(candidate);
      }
      setDraft("");
      setError(false);
      return true;
    },
    [validate, values, onAdd],
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter" || e.key === ",") {
        e.preventDefault();
        commit(draft);
      } else if (e.key === "Backspace" && draft === "" && values.length > 0) {
        onRemove(values[values.length - 1]);
      }
    },
    [commit, draft, values, onRemove],
  );

  const handleBlur = useCallback(() => {
    if (draft.trim()) commit(draft);
  }, [commit, draft]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // TODO:from here it need to lookup from the DB and if it match then need to update that value in the input
      // we could use debounce to delay execution of api call
      // const dummyOptions = [
      //   "John Doe",
      //   "Jane Smith",
      //   "Mike Ross",
      //   "Sarah Chen",
      // ];
      const raw = e.target.value;
      setDraft(raw);
      const candidate = raw.trim().replace(/,$/, "").trim();
      if (!candidate) return true;
      // if (dummyOptions.includes(candidate)) {
      //   if (!values.includes(candidate)) {
      //     onAdd(candidate);
      //   }
      //   setDraft("");
      //   setError(false);
      //   return true;
      // }
      if (!validate(candidate)) {
        setError(true);
        return false;
      }
      if (error) setError(false);
    },
    [error, validate],
  );

  return { draft, error, handleChange, handleKeyDown, handleBlur };
};
